export default __webpack_public_path__ + "assets/ico_start-149623b6.svg";